import type { FC } from "react";
import React from "react";

import { OnlineIndicator } from "../../../../OnlineIndicator";

import type { OnlineIndicatorProps } from "../../../../OnlineIndicator";

const AVATAR_ONLINE_INDICATOR_TEST_ID = "avatar-online-indicator-test-id";

interface IAvatarOnlineIndicatorMainProps
    extends Pick<OnlineIndicatorProps, "size"> {}

interface IAvatarOnlineIndicatorProps
    extends Pick<OnlineIndicatorProps, "view"> {}

export const AvatarOnlineIndicator: FC<IAvatarOnlineIndicatorProps> = (
    props,
) => {
    const { size, ...otherProps } = props as IAvatarOnlineIndicatorProps &
        IAvatarOnlineIndicatorMainProps;

    return (
        <OnlineIndicator
            {...otherProps}
            size={size}
            stroke
            data-tsid={AVATAR_ONLINE_INDICATOR_TEST_ID}
        />
    );
};

AvatarOnlineIndicator.displayName = "Avatar.OnlineIndicator";

export default AvatarOnlineIndicator;
